export default [
  {
    name: 'root',
    label: 'Wrapper',
    selector: '&',
  },
  {
    name: 'before_text',
    label: 'Before Text',
    selector: '& .before-text',
  },
  {
    name: 'typer_text',
    label: 'Typer Text',
    selector: '& .typer-text',
  },
  {
    name: 'after_text',
    label: 'After Text',
    selector: '& .after-text',
  },
];
